import _ from "lodash";
import { BaseApi } from "~/api/abstract/base.api";
import { CatchAll } from "~/error/catch";

class Api extends BaseApi {
  @CatchAll()
  upload(formData: FormData) {
    const headers = { "Content-Type": "multipart/form-data" };
    return this.api.post("", formData, { headers });
  }
}

export const upload = async (
  files: Array<File | undefined>,
  fileKeys: string[],
  apiPath: string,
  data?: Record<string, any>
) => {
  const formData = new FormData();
  fileKeys.forEach((key, index) => {
    const file = files[index];
    if (file) {
      formData.append(key, file);
    }
  });

  if (data) {
    Object.keys(data).forEach((key: string) => {
      const item = data[key];
      const val =
        _.isObjectLike(item) || item === null
          ? JSON.stringify(item)
          : item.toString();
      formData.append(key, val);
    });
  }

  const api = new Api(apiPath);
  return await api.upload(formData);
};
